import type { LanguageCode } from "~/consts/languages"

const saveLanguageKey = "arbeidsark-language-preference"

// Some languages are more specified versions of ones we support.
// For these, we normalise the language string into one we support.
// const languageNormalization: { [locale: string]: string } = {
//   'en-GB': 'en',
//   'en-US': 'en',
//   'nb-NO': 'nb',
//   'nn-NO': 'nn',
// }

export function setPreferredLanguage(language: LanguageCode) {
  localStorage.setItem(saveLanguageKey, language)
}

export function getPreferredLanguage() {
  const saved = localStorage.getItem(saveLanguageKey) as LanguageCode | null

  if (!saved) {
    // Default to Norwegian
    return "nb"
    // TODO: Re-enable this when we are ready to default to the browser default language
    // if/when we go international
    // return (languageNormalization[window.navigator.language] ||
    // window.navigator.language) as LanguageCode
  }

  return saved
}
